
import {useParams } from "react-router";

import { useMetasByIdQuery } from "../../stores/OkOkStore";
import MetasEditForm from "../../components/Metas/MetasEditForm";
import { useTrads } from "../../contexts/trads/useTrads";


function MetasEdit(){
    const params = useParams();
    const {translate}=useTrads();
    const { data: meta, error, isLoading } = useMetasByIdQuery(params.id??"0");

    return (

        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : meta ? (
            <div>
                <MetasEditForm  metaParam={meta} ></MetasEditForm>
            </div>
        ):null
    );
}
export default MetasEdit;